import { render, staticRenderFns } from "./ProfileAbout.vue?vue&type=template&id=31f7fe16"
import script from "./ProfileAbout.vue?vue&type=script&lang=js"
export * from "./ProfileAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports